import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { RepresentanteSharedModule } from '../../../pessoa/representante/representante-shared.module';
import { RepresentantePipeSharedModule } from '../../../pessoa/representante/pipes';

import { CampanhaRepresentanteComponent } from './campanha-representante.component';
import { CampanhaRepresentantePopulaModalComponent } from './popula-modal';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteSharedModule,
        RepresentantePipeSharedModule
    ],
    declarations: [
        CampanhaRepresentanteComponent,
        CampanhaRepresentantePopulaModalComponent
    ],
    exports: [
        CampanhaRepresentanteComponent
    ]
})
export class CampanhaRepresentanteModule { }
